import { AccountClassificationService } from '@/modules/global-settings/onboarder/services/account-classification.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new instance of the AccountClassificationService class
const accountClassificationService = new AccountClassificationService();
// Define the state of the AccountClassification module
export const state = {
  personClasses: []
};
// Define the mutations of the AccountClassification module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the AccountClassification module
export const actions = {
  /**
   * Get person classes
   * @param {Object} object - Vuex context
   * @returns {Array} Array of person classes
   * @private This will set the values in state after fetching
   */
  getPersonClasses: async ({ dispatch, commit }) => {
    try {
      const { data } = await accountClassificationService.getPersonClasses();
      // Chekc if data is null or if it is empty
      if (!data || (data && data.length === 0)) {
        const { data: pData } = await dispatch('createPersonClass');
        commit('SET_PERSON_CLASSES', pData);
        return pData;
      }
      commit('SET_PERSON_CLASSES', data);
      return data;
    } catch (error) {
      Logger.error('getting person classes failed', error);
    }
  },

  /**
   * Create person class
   * @param {Object} object - Vuex context
   * @returns {Array} Array of person classes
   * @private This will re-fetch the person classes after creating
   */
  createPersonClass: async ({ dispatch }) => {
    try {
      const { data } = await accountClassificationService.createPersonClasses();
      dispatch('getPersonClasses');
      return data;
    } catch (error) {
      Logger.error('create person class');
    }
  },

  /**
   * Update person class
   * @param {Object} object - Vuex context
   * @param {Object} payload - Payload to update person class
   * @returns {Object} Updated person class
   */
  updatePersonClass: async (_, payload) => {
    try {
      const { data } = await accountClassificationService.updatePersonClasses(
        payload.id,
        payload
      );
      return data;
    } catch (error) {
      Logger.error('updating person class', error);
    }
  }
};
// Define the getters of the AccountClassification module
export const getters = {
  ...make.getters(state),
  requiredPersonClasses(state) {
    return state.personClasses.filter((i) => i.required == true);
  }
};
